// src/features/treinos/hooks/useExerciseMedia.js
//
// Hook REUTILIZÁVEL: resolve a mídia (vídeo + thumbnail) dos exercícios para
// alimentar o <VideoThumb> em QUALQUER lista de exercícios da aba Treino.
//
// Os exercícios do plano/sessão muitas vezes só trazem nome (e às vezes
// EXERCISE_ID); a mídia mora na exercise_library do Supabase — a MESMA fonte da
// Biblioteca. Carregamos um índice (1x) e resolvemos por EXERCISE_ID OU por NOME.
// Campos inline já presentes no exercício (video_url / URL_VIDEO / thumbnail_url)
// têm prioridade — então exercícios manuais (libToExercicio) seguem funcionando.

import { useCallback, useEffect, useState } from "react";
import {
  loadExerciseMediaIndex,
  resolveExerciseMedia,
} from "../components/treino-screens/exerciseLibraryService.js";

/** Mídia inline já presente no próprio exercício (qualquer grafia conhecida). */
function inlineMedia(ex) {
  const lib = ex?.exercise_library || null;
  return {
    url:
      ex?.video_url ??
      ex?.URL_VIDEO ??
      ex?.video_url_1 ??
      lib?.video_url_1 ??
      lib?.video_url ??
      null,
    url2: ex?.video_url_2 ?? ex?.URL_VIDEO_2 ?? lib?.video_url_2 ?? null,
    thumbnail: ex?.thumbnail_url ?? ex?.thumbnail ?? lib?.thumbnail_url ?? null,
  };
}

/**
 * @param {Array} exercises lista de exercícios (qualquer shape) — só usado para
 *   disparar o carregamento do índice; a resolução é por exercício no getMedia.
 * @returns {(ex) => { url: string|null, url2: string|null, thumbnail: string|null }}
 */
export function useExerciseMedia(exercises = []) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let alive = true;
    loadExerciseMediaIndex().then(() => alive && setReady((r) => !r));
    return () => {
      alive = false;
    };
  }, []);

  return useCallback(
    (ex) => {
      const inline = inlineMedia(ex);
      const lib = resolveExerciseMedia(ex);
      return {
        url: inline.url ?? lib?.video_url ?? null,
        url2: inline.url2 ?? lib?.video_url_2 ?? null,
        thumbnail: inline.thumbnail ?? lib?.thumbnail_url ?? null,
      };
    },
    // `ready` força recriar o resolver quando o índice termina de carregar,
    // então o VideoThumb recebe a URL recém-resolvida.
    [ready],
  );
}
